// extracted by mini-css-extract-plugin
module.exports = {"container":"normal_container__DP_QX","infoItem":"normal_infoItem__pvLdK","label":"normal_label__Gq6WL","value":"normal_value__9H8bT","arrow":"normal_arrow__tO6p6"};